/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_DigitalInputs */

const en_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const es_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const fr_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numérique`)
};

const de_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const ja_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタル`)
};

const zh_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字`)
};

const ar_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رقمي`)
};

const id_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const it_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale`)
};

const ru_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цифровое`)
};

const pt_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const ko_badge_digital = /** @type {(inputs: Badge_DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털`)
};

/**
* | output |
* | --- |
* | "Digital" |
*
* @param {Badge_DigitalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_digital = /** @type {((inputs?: Badge_DigitalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_DigitalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_digital(inputs)
	if (locale === "es") return es_badge_digital(inputs)
	if (locale === "fr") return fr_badge_digital(inputs)
	if (locale === "de") return de_badge_digital(inputs)
	if (locale === "ja") return ja_badge_digital(inputs)
	if (locale === "zh") return zh_badge_digital(inputs)
	if (locale === "ar") return ar_badge_digital(inputs)
	if (locale === "id") return id_badge_digital(inputs)
	if (locale === "it") return it_badge_digital(inputs)
	if (locale === "ru") return ru_badge_digital(inputs)
	if (locale === "pt") return pt_badge_digital(inputs)
	return ko_badge_digital(inputs)
});